module.exports = __webpack_public_path__ + "img/text_4.110e360c.png";